export enum CalendarFilterTracking {
    Live = 'Live',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    In30minutes = 'In 30 Min',
    In3Hours = 'In 3 Hrs',
    In60Minutes = 'In 60 Min',
    In2Days = 'In 2 Days',
    In3Days = 'In 3 Days',
}
